/* eslint-disable @typescript-eslint/no-explicit-any */
import { Injectable } from '@angular/core';
import { ComponentType } from '@angular/cdk/overlay';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';

@Injectable({
  providedIn: 'root'
})
export class LazyDialogService {

  returns: any = {};

  constructor(
    private dialog: MatDialog
  ) {}

  async openDialog(dialogName: string, data: any = false): Promise<MatDialogRef<unknown>> {
    const chunk = await import(
      `../_dialogs/${dialogName}/${dialogName}.component`
    );
    // const dialogComponent = Object.values(chunk)[0] as ComponentType<unknown>;
    const obj = Object.values(chunk)[0];
    const dialogComponent = obj as ComponentType<typeof obj>;
    if (data && !data.data) {
      data = {
        data: data
      };
    }
    return this.dialog.open<typeof obj>(dialogComponent, data);
  }
}
